import UserCustomRoutes from './UserCustomRoutes';

export default UserCustomRoutes;
